// eslint-disable-next-line prettier/prettier
const envSettings = window as any;
class Config {
  static react_app_peacock_url = envSettings.REACT_APP_PEACOCK_URL;
  static react_app_torogoz_url = envSettings.REACT_APP_TOROGOZ_URL;
}

export default Config;
